if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
             const modal = document.querySelector('quick-add-modal[open]');
             const productForm = modal.querySelector('product-form');
              
             if(this.classList.contains('add_on_butterfly')){
                const popup = document.querySelector('.add_on_butterfly_popup.popup');
                const popupContent = popup.querySelector('.add_on_butterfly_popup .popup_content');
                popup.style.display = 'flex';
                popupContent.querySelector('.add_on_butterfly_popup .add_on_butterfly_popup__close').addEventListener('click', function(){
                  popup.style.display = 'none';
                  if (modal) {
                    if (productForm && productForm.cart) {
                      quickAddModal.hide(true);
                      productForm.cart.renderContents(response);
                    } else {
                       console.log('not found');
                    }
                  }
                });
                document.addEventListener('click', function(event) {
                  if (!popupContent.contains(event.target) && popup.contains(event.target)) {
                      popup.style.display = 'none';
                      if (modal) {
                        if (productForm && productForm.cart) {
                          quickAddModal.hide(true);
                          productForm.cart.renderContents(response);
                        } else {
                           console.log('not found');
                        }
                      }
                    }
                });
              }else{
                   document.body.addEventListener(
                      'modalClosed',
                      () => {
                        setTimeout(() => {
                        this.cart.renderContents(response);
                             console.log(this);
                        });
                      },
                      { once: true }
                    );
                  quickAddModal.hide(true);
               }
            } else {
              if(this.classList.contains('add_on_butterfly')){
                const popup = document.querySelector('.add_on_butterfly_popup.popup');
                const popupContent = popup.querySelector('.add_on_butterfly_popup .popup_content');
                popup.style.display = 'flex';
                popupContent.querySelector('.add_on_butterfly_popup .add_on_butterfly_popup__close').addEventListener('click', function(){
                  popup.style.display = 'none';
                  document.querySelector('product-form').cart.renderContents(response);
                });
                document.addEventListener('click', function(event) {
                  if (!popupContent.contains(event.target) && popup.contains(event.target)) {
                      popup.style.display = 'none';
                      document.querySelector('product-form').cart.renderContents(response);
                  }
                });
              }
              else if(this.classList.contains('add_on_butterfly_card')){
                const popup = document.querySelector('.add_on_butterfly_popup_card.popup');
                const popupContent = popup.querySelector('.add_on_butterfly_popup_card .popup_content');
                popup.style.display = 'flex';
                popupContent.querySelector('.add_on_butterfly_popup_card .add_on_butterfly_popup__close').addEventListener('click', function(){
                  popup.style.display = 'none';
                  document.querySelector('product-form').cart.renderContents(response);
                });
                document.addEventListener('click', function(event) {
                  if (!popupContent.contains(event.target) && popup.contains(event.target)) {
                      popup.style.display = 'none';
                      document.querySelector('product-form').cart.renderContents(response);
                  }
                });
              }else{
                this.cart.renderContents(response);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
